import React, { useContext } from 'react';
import { Toast } from 'react-bootstrap';
import { ToastContext } from '../contexts/ToastContext';

/**
 * Renders the global toast stack, anchored bottom-right.
 * Reads from ToastContext provided by AppShell.
 */
export default function ToastContainer() {
  const { toasts, removeToast } = useContext(ToastContext);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container-bottom-right">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          bg={toast.variant}
          onClose={() => removeToast(toast.id)}
          show
          delay={5000}
          autohide
          className="mb-2"
        >
          <Toast.Header closeVariant={toast.variant === 'danger' ? 'white' : undefined}>
            <strong className="me-auto">
              {toast.variant === 'success' && 'Success'}
              {toast.variant === 'danger'  && 'Error'}
              {toast.variant === 'warning' && 'Warning'}
              {toast.variant === 'info'    && 'Info'}
            </strong>
          </Toast.Header>
          <Toast.Body className={toast.variant === 'danger' ? 'text-white' : ''}>
            {toast.message}
          </Toast.Body>
        </Toast>
      ))}
    </div>
  );
}
